<template lang="pug">
#privacy
  section-hero-alt(:title='t("pages.privacy.title")')
  section-privacy
</template>

<script setup>
import { useRoute, useRuntimeConfig } from 'nuxt/app'
import { createPageSchemaContext, createSeoMeta } from '~/utils/schema'

defineOptions({
  name: 'Privacy',
})

const route = useRoute()
const runtimeConfig = useRuntimeConfig()
const { t } = useI18n()
const { pageUrl } = createPageSchemaContext(
  route.path,
  runtimeConfig.public.baseUrl,
)
const description = t('seo.privacyDescription')

useSeoMeta(createSeoMeta(t('pages.privacy.title'), description, pageUrl))
</script>
